import React, { useEffect } from 'react'
import { Card, Avatar, Chip, Typography, IconButton, ListItem, ListItemText, Grid, Tooltip } from '@mui/material'
import { Button } from '../../Common/ui/button'
import { IoMdArrowRoundBack } from 'react-icons/io'
import { MdOutlineModeEditOutline } from 'react-icons/md'
import { BiSolidCopy } from 'react-icons/bi'
import { RxCross2 } from 'react-icons/rx'
import * as RoutePaths from '../../Entities/RoutePath'
import { BsDot } from 'react-icons/bs'
import dayjs from 'dayjs'
import { useMeetingStore } from '../MeetingScheduler/Store/MeetingStore'
import useCustomNavigate from '../../Common/ui/Navigate'
import UpcomingEvent from '../../Components/MeetingScheduler/UpcomingEvents'
import { RoundCheckbox } from '../../Common/ui/roundcheckbox'

const ViewMeeting = () => {
    const { getViewMeetingDetailsById } = useMeetingStore()
    const customNavigate = useCustomNavigate()
    const meetingDetails = {
        meetingId: '567',
        name: 'Vacancy',
        priority: 'High',
        starttime: '2024-04-11T10:00:00Z',
        endtime: '2024-04-11T10:30:00Z',
        organiserId: 2673,
        organiserName: 'Karim',
        description: 'Hello World',
        mode: 'online',
        platform: 'Team',
        link: 'http://www.teams.com',
        timeZone: '(UTC+5.30) Chennai,Kolkata,Mumbai,New Delhi',
        participants: [
            {
                id: 123,
                name: 'Kajol',
                role: 'Director',
                Dept: 'Finace',
                availablity: 'not available'
            },
            {
                id: 145,
                name: 'Vijay',
                role: 'CEO',
                Dept: 'Manufacturing',
                availablity: 'available'
            }
        ],
        risk: [
            {
                id: 889979,
                type: '',
                priority: 'High',
                description: 'Skillset mismatch'
            },
            {
                id: 889000,
                type: '',
                priority: 'low',
                description: 'Skillset mismatch'
            }
        ],
        governance: [
            {
                id: 9898,
                type: '',
                priority: 'gghj',
                name: 'test'
            },
            {
                id: 9234,
                type: '',
                priority: 'gghj',
                name: 'result'
            }
        ],
        agenda: [
            {
                title: 'give to developer',
                isChecked: true
            },
            {
                title: 'Creating Task',
                isChecked: false
            }
        ],
        mom: [
            'New Requirement', 'Discussion', 'create'
        ],
        actionItem: [
            {
                taskName: 'New Requirement',
                assignTo: 'Abi',
                dueDate: '25 Mar',
                label: 'High'
            },
            {
                taskName: 'Code Review',
                assignTo: 'John',
                dueDate: '26 Mar',
                label: 'Medium'
            },
            {
                taskName: 'Testing',
                assignTo: 'Doe',
                dueDate: '27 Mar',
                label: 'Low'
            }
        ]
    }

    // const getViewMeetingDetailsById = useViewMeetingStore(state => state.getViewMeetingDetailsById)

    const eventsData = [{
        meetTitle: 'Project Kickoff',
        location: 'Zoom',
        startTime: '2024-03-22T09:00:00.000',
        endTime: '2024-03-22T10:00:00.000'
    }, {
        meetTitle: 'Client Presentation',
        location: 'Client Office',
        startTime: '2024-03-23T11:00:00.000',
        endTime: '2024-03-23T12:00:00.000'
    }, {
        meetTitle: 'Weekly Sync',
        location: 'Skype',
        startTime: '2024-03-24T14:00:00.000',
        endTime: '2024-03-24T14:30:00.000'
    }, {
        meetTitle: 'HR Meeting',
        location: 'Conference Room B',
        startTime: '2024-03-25T15:00:00.000',
        endTime: '2024-03-25T16:00:00.000'
    }, {
        meetTitle: 'Team Meeting',
        location: 'Conference Room',
        startTime: '2024-03-21T14:18:53.321',
        endTime: '2024-03-21T15:18:53.321'
    }]
    useEffect(() => {
        const meetingId = '567'
        getViewMeetingDetailsById(meetingId)
    }, [])

    const handleCancel = () => {
        // Implement cancel logic
    }

    const handleSave = () => {
        // Implement save logic
    }

    const handleBackViewMeeting = () => {
        customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.CALENDAR.URI + RoutePaths.CREATE_MEETING.URI, RoutePaths.CREATE_MEETING.NAME)
    }

    const handleCopyLink = () => {
        navigator.clipboard.writeText(meetingDetails.link)
    }

    const calculateDuration = (startTime, endTime) => {
        const start = dayjs(startTime)
        const end = dayjs(endTime)
        const duration = end.diff(start, 'minute')
        return duration
    }

    const formattedStartTime = dayjs(meetingDetails.starttime).format('dddd, h:mm A')
    const formattedEndTime = dayjs(meetingDetails.endtime).format('h:mm A')

    const durationMinutes = calculateDuration(meetingDetails.starttime, meetingDetails.endtime)

    const statusColors = {
        High: { color: 'hsl(var(--danger))' },
        Medium: { color: 'hsl(var(--info))' },
        Low: { color: 'hsl(var(--success))' }
    }

    return (
        <Card className=' view-meeting-container' style={{ backgroundColor: 'hsl(var(--background))' }} >
            <Grid container className='justify-between'>
                <Grid onClick={handleBackViewMeeting}>
                    <IoMdArrowRoundBack className="ml-5 mt-3 text-primary" size={28}/>
                </Grid>
                <Grid>
                    <Button variant="outline" onClick={handleCancel} className="m-3">
                        <MdOutlineModeEditOutline className="mr-2" size={18} /> Meeting
                    </Button>
                    <Button variant="destructive" onClick={handleSave} className="m-3">
                        <RxCross2 className="mr-2" size={18} /> Meeting
                    </Button>
                </Grid>
            </Grid>
            <Grid container className='h-full pb-4 px-2'>
                <Grid item xs={12} sm={9} style={{ backgroundColor: 'hsl(var(--card))' }} >
                    <Grid className=" flex-col gap-4 mx-5 my-4">
                        <Grid container className="justify-between mb-4">
                            <Grid item className="flex-grow font-bold text-lg">{meetingDetails.name}</Grid>
                            <Grid item className='text-danger font-bold text-base'>{meetingDetails.priority} Priority</Grid>
                        </Grid>
                        <Grid container className="justify-between mb-8">
                            <Grid className="flex-grow font-medium">{formattedStartTime} - {formattedEndTime}, {durationMinutes} minutes.</Grid>
                            <Grid className='flex justify-between space-x-2'>
                                <div>Organizer :</div><div className='font-semibold'>{meetingDetails.organiserName}</div>
                            </Grid>
                        </Grid>
                        <div className="border-b mx-3" style={{ borderColor: 'hsl(var(--primary-foreground))', borderWidth: '1.5px' }}></div>
                    </Grid>
                    <Grid item style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                        <div className='text-primary m-5 text-lg font-semibold mb-5'>Meeting Info : </div>
                        <div className='flex mb-3'>
                            <div className='text-primary ml-5 text-base font-medium'>Meeting Description : </div>
                            <div className='ml-3'>{meetingDetails.description}</div>
                        </div>
                        <div className='flex mb-3'>
                            <div className='text-primary ml-5 text-base font-medium'>Mode : </div>
                            <div className='ml-3'>{meetingDetails.mode}</div>
                        </div>
                        <div className='flex mb-3'>
                            <div className='text-primary ml-5 text-base font-medium'>Meeting Platform : </div>
                            <div className='ml-3'>{meetingDetails.platform}</div>
                        </div>
                        <div className='flex mb-3'>
                            <div className='text-primary ml-5 text-base font-medium'>Meeting Link : </div>
                            <div className='ml-3 underline underline-offset-2'>{meetingDetails.link}
                                <span><Tooltip title="Copy Meeting Link" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <IconButton onClick={handleCopyLink} size="small">
                                        <BiSolidCopy color="primary" className='ml-2'/>
                                    </IconButton>
                                </Tooltip>
                                </span></div>
                        </div>
                        <div className='flex mb-3'>
                            <div className='text-primary ml-5 text-base font-medium'>Time Zone: </div>
                            <div className='ml-3'>{meetingDetails.timeZone}</div>
                        </div>
                        <div className='text-primary m-5 text-lg font-semibold mb-3'>Participants: </div>
                        <div className='flex m-5'>
                            {meetingDetails.participants.map((user, index) => (
                                <div key={index} className=' m-1 h-14 flex items-center p-4'>
                                    <Typography className='flex'>
                                        <Avatar>H</Avatar>
                                        <Typography className='flex flex-col justify-center pl-2'>
                                            <Typography fontSize={14}>
                                                {user.name}
                                            </Typography>
                                            <Chip
                                                label={user.availablity}
                                                sx={{
                                                    color: user.availablity === 'available' ? 'hsl(var(--success))' : 'hsl(var(--danger))',
                                                    border: user.availablity === 'available' ? '1px solid hsl(var(--success))' : '1px solid hsl(var(--danger))',
                                                    background: '#fff',
                                                    height: '20px'
                                                }}/></Typography>
                                    </Typography>
                                </div>
                            ))}
                        </div>
                        <div className='text-primary m-5 text-lg font-semibold mb-1'>Risk: </div>
                        <div className='flex'>
                            {meetingDetails.risk.map((risk, index) => (
                                <div key={index} className='m-5 underline underline-offset-2 text-info'>{risk.description}</div>
                            ))}
                        </div>
                        <div className='text-primary m-5 text-lg font-semibold mb-1'>Tagged Governance: </div>
                        <div className='flex'>
                            {meetingDetails.governance.map((gov, index) => (
                                <div key={index} className='m-5 underline underline-offset-2 text-info'>{gov.name}</div>
                            ))}
                        </div>
                        <div className='text-primary m-5 text-lg font-semibold mb-3'>Agenda: </div>
                        <div>
                            {meetingDetails.agenda.map((item, index) => (
                                <div key={index} className='mx-5 mt-5 space-x-3'>
                                    <RoundCheckbox checked={item.isChecked} />
                                    <span>{item.title}</span>
                                </div>
                            ))}
                        </div>
                        <div className='text-primary m-5 text-lg font-semibold'>Minutes of Meeting: </div>
                        <Grid className='mx-5'>
                            {meetingDetails.mom.map((item, index) => (
                                <ListItem key={index}>
                                    <BsDot size={25}/>
                                    <ListItemText primary={item} className='ml-2' />
                                </ListItem>
                            ))}
                        </Grid>
                        <Grid className='mb-5'>
                            <div className='text-primary m-5 text-lg font-semibold mb-3'>Action Item: </div>
                            <Grid container spacing={2}>
                                <Grid item xs={3}>
                                    <div className='text-primary ml-5 text-base font-semibold mb-1'>Task name</div>
                                </Grid>
                                <Grid item xs={3}>
                                    <div className='text-primary ml-5 text-base font-semibold mb-1'>Assign To</div>
                                </Grid>
                                <Grid item xs={3}>
                                    <div className='text-primary ml-5 text-base font-semibold mb-1'>Due Date</div>
                                </Grid>
                                <Grid item xs={3}>
                                    <div className='text-primary ml-5 text-base font-semibold mb-1'>Label</div>
                                </Grid>
                                {meetingDetails.actionItem.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <Grid item xs={3}>
                                            <div className='mx-5'>{item.taskName}</div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className='mx-5'>
                                                <Typography className='flex'>
                                                    <Avatar>{item.assignTo.charAt(0)}</Avatar>
                                                    <Typography className='flex flex-col justify-center pl-2' fontSize={14}>{item.assignTo}</Typography>
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className='mx-5'>{item.dueDate}</div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className='mx-5' style={{ color: statusColors[item.label]?.color }}>{item.label}</div>
                                        </Grid>
                                    </React.Fragment>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={3} className='text-muted mt-5 p-5'style={{ backgroundColor: 'hsl(var(--card))', borderLeft: '2px solid hsl(var(--primary-foreground))' }} >
                    <UpcomingEvent eventsData={eventsData}/>
                </Grid>
            </Grid>
        </Card>
    )
}

export default ViewMeeting
